import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Label } from '@/components/ui/label';
import { FIELD_LABEL } from './fileCardStyles';

/** The asterisk the mockup puts on a required field. */
export function Required() {
  return <span className="text-destructive"> *</span>;
}

/** A field label wearing a mark for what it asks for. */
export default function FieldLabel({
  icon: Icon,
  children,
}: {
  icon: LucideIcon;
  children: ReactNode;
}) {
  return (
    <Label className={cn(FIELD_LABEL, 'mb-1.5 flex items-center gap-1.5')}>
      <Icon className="h-3.5 w-3.5 text-primary" />
      {children}
    </Label>
  );
}
